import { createAction, props } from '@ngrx/store';

import { createFailure, createSuccess } from '../utils/action-utils';
import { CompanyInfo, General, PersonalInfo } from './models/general';

// Get General Actions //
const getGeneralKey = '[Settings] Get General';
export const getGeneral = createAction(getGeneralKey);
export const getGeneralSuccess = createAction(
  createSuccess(getGeneralKey),
  props<{ general: General }>(),
);
export const getGeneralFailure = createAction(
  createFailure(getGeneralKey),
  props<{ error: any }>(),
);

// Update General Personal Info Actions //
const updateGeneralPersonalInfoKey = '[Settings] Update General Personal Info';
export const updateGeneralPersonalInfo = createAction(
  updateGeneralPersonalInfoKey,
  props<{ personalInfo: PersonalInfo }>(),
);
export const updateGeneralPersonalInfoSuccess = createAction(
  createSuccess(updateGeneralPersonalInfoKey),
  props<{ personalInfo: PersonalInfo }>(),
);
export const updateGeneralPersonalInfoFailure = createAction(
  createFailure(updateGeneralPersonalInfoKey),
  props<{ error: any }>(),
);

// Update General Company Info Actions //
const updateGeneralCompanyInfoKey = '[Settings] Update General Company Info';
export const updateGeneralCompanyInfo = createAction(
  updateGeneralCompanyInfoKey,
  props<{ companyInfo: CompanyInfo }>(),
);
export const updateGeneralCompanyInfoSuccess = createAction(
  createSuccess(updateGeneralCompanyInfoKey),
  props<{ companyInfo: CompanyInfo }>(),
);
export const updateGeneralCompanyInfoFailure = createAction(
  createFailure(updateGeneralCompanyInfoKey),
  props<{ error: any }>(),
);
